export enum MAProgressionLogic {
    OFF = 'off',
    MANUALLY_BY_GRADER = 'manually_by_grader'
}
